import { ReportesEstablecimientosService } from '../establecimientos/reportes-establecimientos.service';
import { ReportesCantidadRntEstadoService } from './reportes-cantidad-rnt-estado.service';
import { ModuloAyudaService } from '../../configuracion/modulo-ayuda/modulo-ayuda.service';
import { DocumentoSubcategoriaService } from '../../configuracion/documento-subcategoria/documento-subcategoria.service';
import { CampoAdicionalCategoriaService } from '../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service';
import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { UsuarioService } from '../../configuracion/usuario/usuario.service';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AccionRntService } from '../../configuracion/accion-rnt/accion-rnt.service';
import * as FileSaver from 'file-saver';
import { HttpEventType } from '@angular/common/http';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CompletaInformacionService } from '../../../prestador/pasos/completa-informacion/completa-informacion.service';

@Component({
	// tslint:disable-next-line:indent
	selector: 'app-reportes-cantidad-rnt-estado',
	// tslint:disable-next-line:indent
	templateUrl: './reportes-cantidad-rnt-estado.component.html',
	// tslint:disable-next-line:indent
	styleUrls: ['./reportes-cantidad-rnt-estado.component.scss']
})
export class ReportesCantidadRntEstadoComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerTabla: Array<string>;
	formUsuario: FormGroup;
	camarasLista: Array<CamaraComercioEntry>;
	paginaActual: number;
	adminSuper = RolesUsuario.AdministradorSuper;
	soloConsultaNacional = RolesUsuario.SoloConsultaNacional;
	adminCC = RolesUsuario.AdministradorCC;
	prestador = RolesUsuario.Prestador;
	columnas: Array<any> = [];
	columnasEnvio: any;
	// filtros
	filtro: FormGroup;
	formCheck: FormGroup;
	public isCollapsed = false;
	isExportar = true;
	camaraComercio: string;
	// selects
	categoria: Array<any> = [];
	subcategoria: Array<any> = [];
	estadoRnt: Array<any> = [];
	tipoRNT: Array<any> = [];
	// checkBox
	camaraCheck = false;
	razonSocialCheck = false;
	nitCheck = false;
	departamentoCheck = false;
	municipioCheck = false;
	tipoRntCheck = false;
	numeroRntCheck = false;
	categoriaCheck = false;
	subcategoriaCheck = false;
	estadoRntCheck = false;
	fecha_inicio: any;
	isSelect: boolean;
	exportarForm: FormGroup;
	exportarList = [
		{ id: 'CODIGO_CAMARA', name: 'Código Camara' },
		{ id: 'ANIO', name: 'Año' },
		{ id: 'CANTIDAD_INSCRIPCIONES', name: 'Cantidad Inscripciones' },
		{ id: 'CANTIDAD_RENOVACIONES', name: 'Cantidad Renovaciones' },
		{ id: 'CANTIDAD_ACTUALIZACIONES', name: 'Cantidad Actualizaciones' },
		{ id: 'CANTIDAD_SUSPENSIONES', name: 'Cantidad Suspenciones' },
		{ id: 'CANTIDAD_REACTIVACIONES', name: 'Cantidad Reactivaciones' },
		{ id: 'CANTIDAD_CANCELACIONES', name: 'Cantidad Cancelaciones' },
	];
	minDateFinal: Date;

	constructor(private formBuilder: FormBuilder, private reportesCantidadRntEstadoService: ReportesCantidadRntEstadoService,
		private establecimientoComercioService: EstablecimientoComercioService, public authService: AuthService,
		private estadoRntService: AccionRntService) {

		this.createPagingTable();
		this.createForm();

		const selectAllControl = new FormControl(false);
		const formControl = this.exportarList.map(control => new FormControl(false));
		this.exportarForm = this.formBuilder.group({
			exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
			selectAll: selectAllControl
		});

		this.paginaActual = 1;
	}

	ngOnInit() {
		this.titleTable();
		this.onCamaraSelect();
		this.onChanges();
	}

	createForm() {
		this.filtro = this.formBuilder.group({
			codigo_camara: [null, (this.authService.getRolUser(this.adminSuper)
				|| this.authService.getRolUser(this.soloConsultaNacional)) ? Validators.required : null],
			fecha_inicial: [null, Validators.required],
			fecha_final: [null, Validators.required]
		});

	}

	createPagingTable() {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
	}

	onConsultarRNT(page: number) {
		this.reportesCantidadRntEstadoService.getDataTable({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarRNT(value);
	}

	filtrar() {
		this.paginaActual = 1;
		this.createPagingTable();
		this.onConsultarRNT(1);
	}

	limpiar() {
		this.filtro.reset();
		this.createPagingTable();
		this.onCamaraSelect();
	}

	titleTable() {
		this.headerTabla = ['Año', 'Cantidad Inscripciones', 'Cantidad Renovaciones', 'Cantidad Actualizaciones', 'Cantidad Suspenciones', 'Cantidad Reactivaciones', 'Cantidad Cancelaciones'];
	}

	onCamaraSelect() {
		if (this.authService.getRolUser(this.adminSuper) || this.authService.getRolUser(this.soloConsultaNacional)) {
			this.establecimientoComercioService.getCamaras().subscribe(resultado => {
				if (resultado) {
					this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
					if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
						this.filtro.get('codigo_camara').patchValue(this.authService.getCamaraUser());
						this.camaraComercio = (this.camarasLista.find(x => x.codigo_camara ===
							this.authService.getCamaraUser()).desc_camara);
					}
				}
			});
		}
	}

	submit() {
		const selectedPreferences = this.exportarForm.value.exportarList
			.map((checked, index) => checked ? this.exportarList[index].id : null)
			.filter(value => value !== null);

		this.columnasEnvio = selectedPreferences.join();

		this.reportesCantidadRntEstadoService.generarExportarRnt({ ...this.filtro.value, columnas: this.columnasEnvio })
			.subscribe(resultado => {
				if (resultado.type === HttpEventType.Response) {
					if (resultado.ok) {
						this.saveAsExcelFile(resultado.body, `reporte_catidad_rnt_estado.xlsx`);
					}
				}
			});

	}

	onChanges() {
		this.exportarForm.get('selectAll').valueChanges.subscribe(bool => {
			this.exportarForm
				.get('exportarList')
				.patchValue(Array(this.exportarList.length).fill(bool), { emitEvent: false });
		});

		this.exportarForm.get('exportarList').valueChanges.subscribe(val => {
			const allSelected = val.every(bool => bool);
			if (this.exportarForm.get('selecAll').value !== allSelected) {
				this.exportarForm.get('selectAll').patchValue(allSelected, { emitEvent: false });
			}
		});
	}

	minSelectCheckbox(min = 1) {
		const validator: ValidatorFn = (formArray: FormArray) => {
			const totalSelected = formArray.controls.map(control => control.value)
				.reduce((prev, next) => next ? prev + next : prev, 0);

			return totalSelected >= min ? null : { required: true };
		};
		return validator;
	}

	private saveAsExcelFile(data: any, fileName: string): void {
		FileSaver.saveAs(data, fileName);
	}

	onCheckDate(minDate: NgbDate) {
		this.fecha_inicio = { day: minDate.day, month: minDate.month, year: minDate.year };
	}
}
